import { render } from "./CrudDialog.vue?vue&type=template&id=ae2746d8&scoped=true&ts=true"
import script from "./CrudDialog.vue?vue&type=script&lang=ts"
export * from "./CrudDialog.vue?vue&type=script&lang=ts"

import "./CrudDialog.vue?vue&type=style&index=0&id=ae2746d8&lang=scss&scoped=true"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2746d8"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSkeleton,QBtn,QCardActions,QSpace,QInnerLoading,QSpinnerGears});qInstall(script, 'directives', {ClosePopup});
